import Swiper from "./swiper-bundle.esm.browser.min.js";

if ( !customElements.get( "plp-card-image-slider" ) ) {
    class PlpCardImageSlider extends HTMLElement {
        constructor() {
            super();

            this.swiper = null;
            this.mobileMediaQuery = window.matchMedia( "(max-width: 768px)" );
            this.handleNavigationClick = this.handleNavigationClick.bind( this );
            this.handleViewChange = this.handleViewChange.bind( this );
            this.handleDeviceChange = this.handleDeviceChange.bind( this );
        }

        connectedCallback() {
            this.swiperElement = this.querySelector( ".card-image-slider__swiper" );
            this.slidesContainer = this.querySelector( ".swiper-wrapper" );
            this.previousButton = this.querySelector( ".card-image-slider__previous" );
            this.nextButton = this.querySelector( ".card-image-slider__next" );
            this.collectionBody = this.closest( ".collection__body" );
            this.device = this.dataset.device || "desktop";

            if ( this.swiperElement && this.slidesContainer ) {
                this.setImageOrder( this.collectionBody?.dataset.plpView || "project" );

                this.previousButton?.addEventListener( "click", this.handleNavigationClick );
                this.nextButton?.addEventListener( "click", this.handleNavigationClick );
                document.addEventListener( "plp:view-change", this.handleViewChange );
                this.mobileMediaQuery.addEventListener( "change", this.handleDeviceChange );

                this.updateSliderState();
            }

            return;
        }

        disconnectedCallback() {
            this.previousButton?.removeEventListener( "click", this.handleNavigationClick );
            this.nextButton?.removeEventListener( "click", this.handleNavigationClick );
            document.removeEventListener( "plp:view-change", this.handleViewChange );
            this.mobileMediaQuery.removeEventListener( "change", this.handleDeviceChange );

            this.destroySlider();

            return;
        }

        handleNavigationClick( event ) {
            event.preventDefault();
            event.stopPropagation();

            return;
        }

        handleViewChange( event ) {
            this.setImageOrder( event.detail.view );

            if ( this.swiper ) {
                this.swiper.update();
                this.swiper.slideTo( 0, 0 );
            }

            return;
        }

        handleDeviceChange() {
            this.updateSliderState();

            return;
        }

        updateSliderState() {
            const isMobile = this.mobileMediaQuery.matches;
            const shouldEnableSlider = this.device === "mobile" ? isMobile : !isMobile;

            if ( shouldEnableSlider ) {
                this.initSlider();
            } else {
                this.destroySlider();
            }

            return;
        }

        setImageOrder( view ) {
            const firstSlide = this.slidesContainer?.querySelector( '[data-image-index="0"]' );
            const secondSlide = this.slidesContainer?.querySelector( '[data-image-index="1"]' );

            if ( firstSlide && secondSlide ) {
                if ( view === "product" ) {
                    this.slidesContainer.insertBefore( secondSlide, firstSlide );
                } else {
                    this.slidesContainer.insertBefore( firstSlide, secondSlide );
                }
            }

            return;
        }

        initSlider() {
            if ( !this.swiper && this.swiperElement ) {
                this.swiper = new Swiper( this.swiperElement, {
                    slidesPerView: 1,
                    slidesPerGroup: 1,
                    spaceBetween: 0,
                    speed: 300,
                    grabCursor: true,
                    watchOverflow: true,
                    allowTouchMove: true,
                    navigation: {
                        nextEl: this.nextButton,
                        prevEl: this.previousButton,
                    },
                });
            }

            return;
        }

        destroySlider() {
            if ( this.swiper ) {
                this.swiper.destroy( true, true );
                this.swiper = null;
            }

            return;
        }
    }

    customElements.define( "plp-card-image-slider", PlpCardImageSlider );
}